export enum MetodoAjustePrecoEnum {
    Automatico = 1,
    Manual = 2,
}